import { useState } from "react";
import axios from "axios";
import { toast } from "@/components/ui/sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputClass =
  "w-full bg-white border border-[#DCD5C6] px-4 py-2.5 text-sm font-body text-ink focus:outline-none focus:border-clay";
const labelClass =
  "block font-mono text-xs uppercase tracking-wider text-ink mb-1";

export default function LeadForm({ idPrefix, onSuccess }) {
  const [form, setForm] = useState({
    name: "",
    work_email: "",
    organization: "",
    requirements: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await axios.post(`${API}/leads`, form);
      toast.success("Request received", {
        description: "Thank you — the SureLoom team will be in touch shortly.",
      });
      setForm({ name: "", work_email: "", organization: "", requirements: "" });
      onSuccess?.();
    } catch (err) {
      toast.error("Submission failed", {
        description: "Please check your details and try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form
      className="p-8 border border-ink bg-ivory space-y-5"
      onSubmit={handleSubmit}
      data-testid={`${idPrefix}-form`}
    >
      <div>
        <label className={labelClass} htmlFor={`${idPrefix}-name`}>
          Name
        </label>
        <input
          id={`${idPrefix}-name`}
          type="text"
          className={inputClass}
          required
          value={form.name}
          onChange={set("name")}
          data-testid={`${idPrefix}-name-input`}
        />
      </div>
      <div>
        <label className={labelClass} htmlFor={`${idPrefix}-email`}>
          Work Email
        </label>
        <input
          id={`${idPrefix}-email`}
          type="email"
          className={inputClass}
          required
          value={form.work_email}
          onChange={set("work_email")}
          data-testid={`${idPrefix}-email-input`}
        />
      </div>
      <div>
        <label className={labelClass} htmlFor={`${idPrefix}-org`}>
          Organization
        </label>
        <input
          id={`${idPrefix}-org`}
          type="text"
          className={inputClass}
          required
          value={form.organization}
          onChange={set("organization")}
          data-testid={`${idPrefix}-org-input`}
        />
      </div>
      <div>
        <label className={labelClass} htmlFor={`${idPrefix}-note`}>
          Deployment Requirements
        </label>
        <textarea
          id={`${idPrefix}-note`}
          rows={3}
          className={inputClass}
          value={form.requirements}
          onChange={set("requirements")}
          data-testid={`${idPrefix}-requirements-input`}
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="w-full py-4 bg-ink text-white hover:bg-clay transition-colors font-mono text-xs uppercase tracking-widest font-bold disabled:opacity-60"
        data-testid={`${idPrefix}-submit-btn`}
      >
        {submitting ? "Submitting..." : "Submit Request"}
      </button>
    </form>
  );
}
